import 'babel-polyfill';
import { instance } from '../utils/axiosInstance'


export class SalesPersonApi {
    static async getSalesPayroll() {
        return instance.get('/salespeople');
    }
    static async createSalesPerson(salespersonData){
        return instance.post('/salesperson', salespersonData)
    }
    static async updateResource(userId, resourceData){
        return instance.put('/user/' + userId, resourceData)
    }
    static async updateSalesResources(salesPeopleId, data){
        return instance.put('/users', salesPeopleId, data)
   
    }
}



// WEBPACK FOOTER //
// ./src/api/salespeopleApi.js